import React from "react";

export default function PageHeader({ eyebrow, title, description, actions, testId }) {
  return (
    <div
      data-testid={testId || "page-header"}
      className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 border-b border-stone-200 pb-6"
    >
      <div>
        {eyebrow && <div className="overline text-brand-600 mb-2">{eyebrow}</div>}
        <h1 className="font-display text-3xl md:text-4xl font-black tracking-tight text-stone-950">
          {title}
        </h1>
        {description && (
          <p className="text-stone-600 mt-2 max-w-2xl text-base">{description}</p>
        )}
      </div>
      {actions && <div className="flex gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}
